// Define action types
export const SET_PRIVELEGED_RESPONSE = 'SET_PRIVELEGED_RESPONSE';

// Define action creators
export const setPrivelegedResponse= (response) => ({
  type: SET_PRIVELEGED_RESPONSE,
  payload: response,
});
